import axios from 'axios'

export default function redemptionErrorHandler(
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  error: any,
  dispatch: (action: string, reasonObject : { reason: string }, optionsObject: { root: boolean }) => void,
): string[] {
  if (!axios.isAxiosError(error)) {
    throw error
  }

  if (!error.response) {
    throw error
  }

  const { response } = error

  if (error.response.status === 429) {
    if (response.data.errors && Array.isArray(response.data.errors)) {
      if (response.data.errors[0] === 'too_many_retries') {
        dispatch('redemptions/failRedemption', { reason: 'TOO_MANY_RETRIES' }, { root: true })
        dispatch('redemptions/setErrors', response.data, { root: true })
        return response.data.errors
      }
    }

    return ['throttle']
  }

  if (response.data && [422, 404, 400].includes(response.status)) {
    if (response.data.errors && Array.isArray(response.data.errors)) {
      return response.data.errors
    }
  }
  return ['general']
}
